module.exports = __webpack_public_path__ + "assets/img/zre4.ff2d90aa.png";